// Espelha ClientPortalUserViewModel do backend (change acesso-so-por-perfil: o vínculo tem UM perfil de portal).
export interface ClientPortalUser {
  userId: string;
  email?: string | null;
  dtCreated?: string;
  /** Perfil de acesso do vínculo; null para vínculo legado ainda sem perfil. */
  profileId: number | null;
  profileName: string | null;
  podeVerChamados: boolean;
  podeVerProjetos: boolean;
  podeVerHoras: boolean;
  podeVerFinanceiro: boolean;
}

/** Item de GET /Client/portal-profiles: perfil com `clientportal.view` e as áreas que ele concede. */
export interface PortalProfile {
  id: number;
  name: string;
  podeVerChamados: boolean;
  podeVerProjetos: boolean;
  podeVerHoras: boolean;
  podeVerFinanceiro: boolean;
}

type PortalAreaKey = "podeVerChamados" | "podeVerProjetos" | "podeVerHoras" | "podeVerFinanceiro";

// Corpo de POST /Client/Clients/{id}/users (GrantClientAccessRequest).
export interface GrantClientAccessRequest {
  email: string;
  password: string | null;
  /** Omitido => o backend usa o perfil "Cliente – Chamados" (só Chamados). */
  profileId?: number;
}

export const PORTAL_AREA_OPTIONS: { key: PortalAreaKey; label: string }[] = [
  { key: "podeVerChamados", label: "Chamados" },
  { key: "podeVerProjetos", label: "Projetos e cronograma" },
  { key: "podeVerHoras", label: "Horas" },
  { key: "podeVerFinanceiro", label: "Financeiro" },
];
